<template>
  <div class="row row-height">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :height="height"
      :is-full-page="fullPage"
      :width="width"
      background-color="#6b6969"
      loader="dots"
    />
    <div class="col-md-5 col-sm-12">
      <form
        class="custom-container-fluid center_item"
        @submit.prevent="submitForm"
      >
        <div class="row">
          <div class="col-md-12 text-center">
            <router-link to="/">
              <img
              src="@/assets/logo_white.png"
              style="width:120px;"
              class="img-fluid"
              alt=""
            />
            </router-link>
            <h1 class="text-green">Welcome</h1>
            <p style="color: #727272">
              Enter your credentials to login to your student portal
            </p>
          </div>
          <div class="col-md-12 mt-5">
            <div class="form-group">
              <label for="email">EMAIL</label> <br />
              <div :class="[emailPasswordError ? 'form-invalid' : '']">
                <input
                  type="email"
                  v-model="data.email"
                  required
                  class="w-100 form-control"
                  id="email"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-4">
              <label for="password">PASSWORD</label> <br />
              <div :class="[emailPasswordError ? 'form-invalid' : '']">
                <input
                  type="password"
                  v-model="data.password"
                  class="w-100 form-control"
                  id="password"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <router-link to="#" v-if="emailPasswordError" class="text-danger"
              ><i class="fa fa-info-circle" /> Incorrect login name /
              password</router-link
            >
          </div>
          <div class="col-md-6 text-right">
            <router-link to="#" style="color: #727272"
              >Forgot Password</router-link
            >
          </div>

          <div class="col-md-12 text-center mt-5">
            <button type="submit" class="btn btn-orange btn-curve">
              Sign in
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-7 backImage d-none d-md-block"></div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      emailPasswordError: false,
      data: {
        email: "",
        password: ""
      },
      fullPage: true,
      height: 128,
      width: 128,
      isLoading: false
    };
  },
  components: {
    Loading
  },
  methods: {
    submitForm() {
      this.isLoading = true;
      this.$store
        .dispatch("retrieveToken", this.data)
        .then(() => {
          this.$router.push("/dashboard");
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            title: "Error!",
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "Close"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.row-height {
  height: 100vh;
}
.top_space {
  margin-top: 5rem;
}

@media only screen and (max-width: 768px) {
  .top_space {
  }
}

.form-invalid {
  border-radius: 0.2rem;
  border: 1px solid #c03221;
}

.form-control {
  background: rgba(228, 228, 228, 0.7);
  border: none;
  border-left: 2px solid #059ca6;
  height: 55px;
}

.form-group > label {
  font-size: 16px;
}
.backImage {
  background: url("../../public/assets/img/register_img.png") no-repeat center;
  background-size: cover;
  background-position-y: center;
}
</style>
